import cx from "classnames";
import type { useClickOutside } from "src/hooks/useClickOutside";
import type { Row } from "../../FabButton.types";
import { getPanelClip, getPanelStateClass } from "../../FabButton.utils";

type FabButtonPanelProps = {
  open: boolean;
  fabSize: number;
  rows: Row[];
  onMouseDownCapture: ReturnType<typeof useClickOutside>;
};

const FabButtonPanel = ({
  open,
  fabSize,
  rows,
  onMouseDownCapture,
}: FabButtonPanelProps) => {
  const { clipPath, transformOrigin } = getPanelClip(fabSize, open);

  return (
    <div
      className={cx(
        // Collapsed: no box radius — clip-path alone shapes the disc (rounded-3xl
        // + overflow-hidden would cut into a 30px BR circle).
        "relative w-80 overflow-hidden border transition-all will-change-[clip-path] motion-reduce:transition-none",
        open ? "rounded-3xl" : "rounded-none",
        getPanelStateClass(open)
      )}
      style={{ clipPath, transformOrigin }}
      onMouseDownCapture={onMouseDownCapture}
    >
      <div
        inert={!open}
        className={cx(
          "max-h-[70vh] overflow-y-auto p-2 transition-opacity duration-300 motion-reduce:transition-none",
          open ? "pointer-events-auto opacity-100" : "pointer-events-none opacity-0"
        )}
      >
        {rows.map(({ key, node }, i) => (
          <div
            key={key}
            className={cx(
              "transition-all duration-300 ease-out motion-reduce:transition-none",
              open ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"
            )}
            style={{ transitionDelay: open ? `${120 + i * 45}ms` : "0ms" }}
          >
            {node}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FabButtonPanel;
